import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../hooks/useRouter';
import Urls from '../profile/Urls';
import DataCard from './DataCard';
import useUserTags from '../../hooks/useUserTags';
import TagTypes from '../../constants/TagTypes';

export default function Groups(props) {
  const { user } = props;

  const { history } = useRouter();

  const [timestamp] = useState(new Date().toISOString());

  const userGroups = useUserTags(user, TagTypes.Group, timestamp);

  let subtitle = '';

  if (userGroups.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = userGroups.data.map(function(userGroup, index) {
      return (
        <div key={index}>
          {userGroup._tag.data.name}
        </div>
      );
    });
  }

  return (
    <DataCard
      title="Youth Groups"
      icon={UsersIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(user).GROUPS)}
    />
  );
};
